export default {
    // 查询组织架构信息
    find(params, response) {
        window.vue.$apiAxios.postRequestBody('/OrgManagerController/find', params, response);
    },

    // 查询组织架构信息
    findOrgStructure(params, response) {
        window.vue.$apiAxios.postRequestBody('/OrgStructureController/findOrgStructure', params, response);
    },

    // 添加组织架构
    insertOrgStructure(params, response) {
        window.vue.$apiAxios.postRequestBody('/OrgStructureController/insertOrgStructure', params, response);
    },

    // 编辑组织架构
    updateOrgStructure(params, response) {
        window.vue.$apiAxios.postRequestBody('/OrgStructureController/updateOrgStructure', params, response);
    },

    // 删除组织架构
    deleteOrgStructure(params, response) {
        window.vue.$apiAxios.postRequestBody('/OrgStructureController/deleteOrgStructure', params, response);
    },

    // 检测编号是否重复
    checkStructureCodeRepeat(params, response) {
        window.vue.$apiAxios.postRequestBody('/OrgStructureController/checkStructureCodeRepeat', params, response);
    },

    // 树形拖动排序
    orgSort(params, response) {
        window.vue.$apiAxios.postRequestBody('/OrgManagerController/orgSort', params, response);
    },

    // 导入组织架构
    uploadOrgStructureZip(params, response) {
        window.vue.$apiAxios.postRequestBody('/OrgStructureController/uploadOrgStructureZip', params, response);
    },

    // 导出
    exportOrgStructureCsv(params, responseType, response) {
        window.vue.$apiAxios.downloadPost('/OrgStructureController/exportOrgStructureCsv', params, responseType, response);
    },

    // 查询职位信息
    queryStationInfo(params, responseType, response) {
        window.vue.$apiAxios.get('/OrgStructureController/queryStationInfo', params, responseType, response);
    }
};
